<template>
  <div>
    <LoadingSpinner v-if="loadingOptionsList || loadingBillingInfo" />
    <div v-if="!loadingOptionsList && !loadingBillingInfo">
      <main>
        <div class="row mt-4">
          <div class="col-md-12">
            <h4 class="mt-4">Billing Info</h4>
            <h5 class="mt-4">
              {{ $t("lang.label.paymentprofile") }}
            </h5>
            <div class="mt-4">
              <div class="card collegues p-4" v-if="allInfo.paymentProfile !== null">
                <div>
                  <b>{{ $t("lang.label.name") }}</b>:
                  {{ allInfo.paymentProfile.name }}
                </div>

                <div>
                  <b>{{ $t("lang.label.legalrepresentative") }}</b>:
                  {{ allInfo.paymentProfile.legal_representative }}
                </div>
                <div>
                  <b>{{ $t("lang.label.address") }}</b>:
                  {{ allInfo.paymentProfile.address }}
                </div>
                <div>
                  <b>{{ $t("lang.label.country") }}</b>:
                  {{ getCountry() }}
                </div>
                <div>
                  <b>{{ $t("lang.label.email") }}</b>:
                  {{ allInfo.paymentProfile.contact_email }}
                </div>
                <div v-if="subscriptionFree == 1">
                  <b class="text-danger">{{ $t("lang.label.subscription_paused") }}</b>
                </div>
                <div v-else-if="displayedNextPaymentDate">
                  <b>{{ $t("lang.label.next_payment_date") }}</b>:
                  {{ displayedNextPaymentDate }}
                  <span
                    v-if="true"
                    class="ml-1"
                  >
                    ({{ billingTrigger }})
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <h5 class="mt-4">
          {{ $t("lang.label.paymentmethods") }}
        </h5>
        <div class="mx-0 mt-1 px-0 table-responsive card p-2">
          <Table v-if="paymentMethods.length > 0" class="mx-2 w-100" :headers="headersPayment" :cols="colsPayment"
            :data="paymentMethods" :checkbox="false" :notselect="true" :model="model" :fieldsLoading="fieldsLoading"
            :key="key" @downloadMandatSepa="downloadMandatSepa($event)">
          </Table>
          <div class="row" v-else>
            <div class="col-12 col-md-10 offset-md-1 text-center ">
              <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
                <h6>
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No method payment to show
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin" class="mx-0 mt-2 px-0 card p-3">
          <h6 class="mb-1">{{ $t("lang.label.preferred_payment_method") }}</h6>
          <small class="text-muted mb-2">{{ $t("lang.label.preferred_payment_method_help") }}</small>
          <div class="d-flex flex-wrap align-items-center">
            <select v-model="selectedPreferredMethod" class="form-control form-control-sm w-auto mr-2 mb-1">
              <option :value="null" disabled>-</option>
              <option v-for="option in preferredMethodOptions" :key="option.key" :value="option.key">
                {{ option.label }}
              </option>
            </select>
            <button class="btn btn-primary btn-sm mb-1" :disabled="!selectedPreferredMethod || savingPreferredMethod"
              @click="changePreferredPaymentMethod">
              {{ $t("lang.label.change_preferred_payment_method") }}
            </button>
          </div>
        </div>

        <!-- <div class="row mt-4">
          <div class="col-md-12">
            <h5>
              {{ $t("lang.label.paymentmethods") }}
            </h5>
            <div class="collegues mt-4">
              <div class="">
                <div class="row">
                  <div
                    v-for="(paymentmethod, key) in allInfo.paymentmethod"
                    :key="key"
                    class="col-sm-6 col-md-3 p-2"
                  >
                    <div class="card p-4">
                      <div>
                        <div class="d-flex align-items-center">
                          <div class="collegues-img mr-3">
                            <i
                              class="icon-credit-card mr-3"
                              style="font-size: 40px"
                            ></i>
                          </div>
                          <div>
                            <strong>{{
                              paymentmethod.descriptionPayment
                            }}</strong>
                            <span
                              class="badge ml-2"
                              v-if="paymentmethod.deleted == ''"
                              :class="
                                paymentmethod.valid == 'Valid'
                                  ? 'badge-info'
                                  : 'badge-danger'
                              "
                              >{{ paymentmethod.valid }}</span
                            >
                            <span v-else class="badge badge-secondary ml-2">{{
                              paymentmethod.deleted
                            }}</span>
                            <div>
                              <small>{{ paymentmethod.name }}</small>
                            </div>
                            <div>
                              <small>{{ paymentmethod.isDefault }}</small>
                            </div>
                            <div v-if="paymentmethod.payment_type === 'sepa'">
                              <strong>EDI{{ String(paymentmethod.id).padStart(10, '0') }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div>
          <div>
            <h5 class="mt-4"> {{ $t("lang.label.invoices") }}</h5>
          </div>
          <div class="float-right mb-2">
            <button class="btn btn-primary btn-sm" @click="openModal('newInvoiceModal')">
              {{ $t("lang.button.new_invoice") }}
            </button>
          </div>
        </div>
        <div class="mx-0 mt-1 px-0 table-responsive card p-2">
          <Table v-if="invoices.length > 0" class="mx-2 w-100" :headers="headersInvoices" :cols="colsInvoices"
            :data="invoices" :checkbox="false" :notselect="true" :model="model" :fieldsLoading="fieldsLoading"
            :key="key" @goToDownloadPDF="goToDownloadPDF($event)">
          </Table>
          <div class="row" v-else>
            <div class="col-12 col-md-10 offset-md-1 text-center ">
              <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
                <h6>
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No Invoices to show
                </h6>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row mt-4">
          <div class="col-md-12">
            <h5>
              {{ $t("lang.label.invoices") }}
            </h5>
            <div class="collegues mt-4">
              <div class="">
                <div class="row">
                  <div
                    v-for="(invoice, key) in allInfo.invoice"
                    :key="key"
                    class="col-sm-6 col-md-3 p-2"
                  >
                    <div class="card p-4">
                      <div>
                        <div class="d-flex align-items-center">
                          <div>
                            <span class="badge badge-success mr-2">{{
                              invoice.payment_type_name
                            }}</span>
                            <span
                              >{{ invoice.date }} - {{ invoice.amount }} €</span
                            >
                            <span class="badge badge-success ml-2">{{
                              invoice.status
                            }}</span>
                            <i
                              @click="downloadPDF(invoice)"
                              class="icon-arrow-down ml-3 cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row mt-4">
          <div class="col-md-4">
            <h5>
              {{ $t("lang.label.expenses") }}
            </h5>
            <div class="card mt-4">
              <div class="pt-4" v-if="!loadingStats">
                <UsageStatsTable :statsClient="statsClient" :statsType="statsType1" :statsDate="statsDate"
                  :statsTypeText="statsType1Text" />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <h5>
              {{ $t("lang.label.failedtransactions") }}
            </h5>
            <div class="mt-4">
              <div class="pt-4 col-md-12" v-if="!loadingStats">
                <table class="table table-striped">
                  <thead>
                    <th>Payment</th>
                    <th>Card number</th>
                    <th>Viva Transaction ID</th>
                    <th>Info</th>
                  </thead>
                  <tbody>
                    <tr v-for="(transaction, key) in allInfo.transactions" :key="'tr-' + key">
                      <td>
                        <b>{{ getInvoiceId(transaction) }}</b>
                        <br>
                        <span class="small">{{ transaction.created }}</span>
                      </td>
                      <td>
                        {{ transaction.card_number }}
                        <span class="small">({{ transaction.attempt }})</span>
                      </td>
                      <td>
                        {{ transaction.transaction_id }}
                      </td>
                      <td>
                        {{
                          $t("lang.viva_payments.code_" + transaction.event_id)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Modal :name="'newInvoiceModal'" class="modal-preview p-2" :size="'45'" :close="true" height="100"
        style="z-index: 10">
        <div class="p-2 my-4 w-100">
          <h3 class="text-center font-weight-bold">{{ $t("lang.label.new_invoice") }}</h3>
          <div class="d-flex flex-column align-items-center mt-3">
            <div class="w-100" style="max-width: 480px;">
              <div class="mb-3">
                <h6 class="font-weight-bold">{{ $t("lang.column.description") }}</h6>
                <textarea v-model="descriptionInvoice" class="form-control" rows="3"
                  placeholder="Invoice description"></textarea>
              </div>
              <div class="mb-3">
                <h6 class="font-weight-bold">{{ $t("lang.column.amount") }}</h6>
                <input v-model="amountInvoice" type="number" min="0" class="form-control" placeholder="Amount ...">
              </div>
              <div class="d-flex justify-content-center mt-4">
                <button class="btn btn-secondary mr-2" @click="closeModal('newInvoiceModal')">{{
                  $t("lang.button.cancel") }}</button>
                <button class="btn btn-success"
                  @click="CreateNewInvoice(descriptionInvoice, amountInvoice, invoiceClientId)">{{
                    $t("lang.button.create_invoice") }}</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import UsageStatsTable from "@/components/Usages/UsageStatsTable.vue";
import Table from "@/components/Common/Table.vue";
import Modal from "@/components/Common/Modal.vue";
import { usersService, billingsService, adminService } from '@/_services'
import {
  statusBadgeMixin,
  statusPointMixin,
  pdfInvoiceMixin,
} from "@/_mixins/";

export default {
  props: {
    userId: {
      type: String,
      default: "0",
    },
    nextPaymentDate: {
      type: String,
      default: false
    },
    subscriptionFree: {
      default: 0,
    },
    subscriptionDeferredBilling: {
      default: 0,
    },
    billingTrigger: {
      default: "",
    },
    kickoffDate: {
      default: "",
    },
  },
  mixins: [pdfInvoiceMixin],
  components: {
    LoadingSpinner,
    UsageStatsTable,
    Table,
    Modal,
  },
  data() {
    return {
      loadingStats: true,
      loadingBillingInfo: true,
      descriptionInvoice: "",
      amountInvoice: "",
      invoiceClientId: null,
      selectedPreferredMethod: null,
      savingPreferredMethod: false,
      paymentMethods: [],
      invoices: [],
      allInfo: {},
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      fieldsLoading: true,
      key: 1,
      statsClient: {},
      statsDate: [],
      statsType: [
        "charged",
        "uncharged",
        "declined",
        "planned",
        "absent",
        "canceled",
      ],
      statsType1: [
        "charged",
        "uncharged",
        "subscription_exonerated",
        "credit",
        "subscription_canceled",
        "declined",
        "planned",
      ],
      statsType1Text: [
        "Charged",
        "Uncharged",
        "Exonerated",
        "Credit",
        "Recovery",
        "Declined",
        "Planned",
      ],
      statsType2: ["absent", "canceled"],
      headersPayment: [
        {
          label: "Id",
          percentage: "5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Name",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Description",
          percentage: "20%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Payment Type",
          percentage: "15%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Default",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Status",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Actions",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        }
      ],
      colsPayment: [
        [
          {
            value: "id"
          }
        ],
        [
          {
            value: "name"
          }
        ],
        [
          {
            value: "descriptionPayment"
          }
        ],
        [
          {
            value: "payment_type",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "cc",
                label: "Credit Card",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "sepa",
                label: "SEPA",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "bank_transfer",
                label: "Bank Transfer",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
            ]
          },
          {
            value: "sepa_direct_credit",
            type: "itemBadge",
            class: "badge ml-2",
            colors: [
              {
                id: 0,
                label: "NEW",
                bgColor: "#00c853",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "isDefault",
            format: 1,
            label: "Yes",
            default: "No",
            type: "btnIfNotNull"
          }
        ],
        [
          {
            value1: "deleted",
            value2: "valid",
            format: 2,
            type: "btnIfNotNull"
          }
        ],
        [
          {
            btnId: "id",
            name: "Download Mandat SEPA",
            value_if: "payment_type",
            type: "btnIfNotNull",
            format: 4,
            emit: "downloadMandatSepa",
          }
        ],
      ],
      headersInvoices: [
        {
          label: "Invoice ID",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Date",
          percentage: "15%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Amount",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Tax",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Amount (inc. tax)",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Status Payment",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 5,
        },
        {
          label: "Payment method",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 8,
        },
        {
          label: "Product",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 6,
        },
        {
          label: "Actions",
          percentage: "10%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 7,
        },
      ],
      colsInvoices: [
        [
          {
            value: "id"
          }
        ],
        [
          {
            value: "date"
          }
        ],
        [
          {
            value: "amount_without_vat",
            format: "money",
            simbol: "€",
          }
        ],
        [
          {
            value: "vat",
            format: "money",
            simbol: "€",
          }
        ],
        [
          {
            value: "amount",
            format: "money",
            simbol: "€",
          }
        ],
        [
          {
            value: "status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "Paid",
                label: "Paid",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Another method",
                label: "Paid",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Exonerated",
                label: "Exonerated",
                bgColor: "yellow",
                textColor: "#FFFFFF",
              },
              {
                id: "Declined",
                label: "Declined",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "Recovery",
                label: "Recovery",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "Processing",
                label: "Processing",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "Pending bank",
                label: "Pending bank",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "SEPA Direct Debit",
                label: "SEPA Direct Debit",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Pending approval",
                label: "Pending Approval",
                bgColor: "yellow",
                textColor: "#FFFFFF",
              },
            ]
          }
        ],
        [
          {
            value: "payment_method_display",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "credit_card",
                label: "Card",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "sepa",
                label: "SEPA",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "bank_transfer",
                label: "Bank transfer",
                bgColor: "yellow",
                textColor: "#000000",
              },
              {
                id: "manual",
                label: "Manual",
                bgColor: "grey",
                textColor: "#FFFFFF",
              },
              {
                id: "none",
                label: "-",
                bgColor: "transparent",
                textColor: "#000000",
              },
            ]
          }
        ],
        [
          {
            value: "payment_type_name",
            type: "itemBadge",
            colors: [
              {
                id: "Leads Oliver",
                label: "Leads Oliver",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "License(s) Oliver",
                label: "License(s) Oliver",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Custom",
                label: "Custom",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
            ]
          }
        ],
        [
          {
            btnId: "id",
            name: "Download PDF",
            value_if: "id",
            type: "btnIfNotNull",
            emit: "goToDownloadPDF",
            loading_data: [],
          }
        ],
      ],
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      loadingOptionsList: (state) => !state.optionsList.completeLoading,
      profileCountries: (state) =>
        state.optionsList.all["profile_countries"].data,
    }),
    displayedNextPaymentDate() {
      return this.nextPaymentDate || "";
    },
    isAdmin() {
      return this.currentUser && this.currentUser.role_id == 1;
    },
    preferredMethodOptions() {
      const options = [
        { key: "bank_transfer", type: "bank_transfer", id: null, label: this.$t("lang.label.bank_transfer") },
      ];
      (this.paymentMethods || []).forEach((method) => {
        if (method.deleted) {
          return;
        }
        if (method.payment_type === "sepa") {
          options.push({
            key: `sepa-${method.id}`,
            type: "sepa",
            id: method.id,
            label: `SEPA EDI${String(method.id).padStart(10, "0")} - ${method.descriptionPayment}`,
          });
        } else if (method.payment_type === "cc" && method.valid === "Valid") {
          options.push({
            key: `cc-${method.id}`,
            type: "credit_card",
            id: method.id,
            label: `CB ${method.descriptionPayment}`,
          });
        }
      });
      return options;
    },
  },
  created() {
    this.getAllOptionsList();
    this.getBillingInfo();
  },
  watch: {
    allInfo: {
      deep: true,
      handler() {
        this.formatCientStats();
      },
    },
  },
  methods: {
    ...mapActions("optionsList", {
      getAllOptionsList: "getAll",
    }),
    closeModal(modal) {
      this.$modal.hide(modal);
    },
    downloadMandatSepa(id) {
      billingsService.downloadMandatSepa(id).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename || `Mandat_SEPA_Oliverlist_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    openModal(modal) {
      if (modal == 'newInvoiceModal') {
        this.descriptionInvoice = "";
        this.amountInvoice = "";
        this.invoiceClientId = this.$route.params.id;
      }
      this.$modal.show(modal);
    },
    CreateNewInvoice(description, amount, client_id) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then(result => {
        if (result.value) {
          // console.log("Creating invoice with description:", description, "amount:", amount, "client_id:", client_id);
          billingsService.createInvoiceClient(description, amount, client_id).then((response) => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 2500,
            });
          })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                text: error.message || this.$t("lang.label.errorwhilesavingdata"),
              });
            })
            .finally(() => {
              this.closeModal('newInvoiceModal');
            });
        }
      });
    },
    changePreferredPaymentMethod() {
      const option = this.preferredMethodOptions.find((o) => o.key === this.selectedPreferredMethod);
      if (!option) {
        return;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: `${option.label}. ${this.$t("lang.label.preferred_payment_method_help")}`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (!result.value) {
          return;
        }
        this.savingPreferredMethod = true;
        adminService
          .setClientPaymentMethod(this.$route.params.id, option.type, option.id)
          .then((response) => {
            const openPayments = (response && response.open_payments) || [];
            this.$swal({
              type: "success",
              title: this.$t("lang.label.preferred_payment_method_updated"),
              text: `${this.$t("lang.label.open_invoices")}: ${openPayments.length}`,
              showConfirmButton: false,
              timer: 4000,
            });
            this.selectedPreferredMethod = null;
            this.getBillingInfo();
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: (typeof error === "string" ? error : error && error.message) || this.$t("lang.label.errorwhilesavingdata"),
            });
          })
          .finally(() => {
            this.savingPreferredMethod = false;
          });
      });
    },
    getBillingInfo() {
      this.loadingBillingInfo = true;
      usersService.getUserById(this.userId).then((response) => {
        this.allInfo = response;
        this.paymentMethods = this.processPaymentMethods(this.allInfo.paymentmethod);
        this.invoices = this.allInfo.invoice
          .map((invoice) => ({
            ...invoice,
            payment_method_display: this.getPaymentMethodDisplay(invoice),
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date));
        this.loadingBillingInfo = false;
      });
    },
    getPaymentMethodDisplay(invoice) {
      if (Number(invoice.payment_status_id) === 5) {
        return "manual";
      }
      if (["credit_card", "sepa", "bank_transfer"].includes(invoice.payment_method_type)) {
        return invoice.payment_method_type;
      }
      return "none";
    },
    processPaymentMethods(paymentMethods) {
      if (!paymentMethods || !Array.isArray(paymentMethods)) {
        return [];
      }
      return paymentMethods.map((method) => {
        // Si es SEPA y no tiene nombre, extraerlo del descriptionPayment
        if (method.payment_type === 'sepa' && (!method.name || method.name.trim() === '')) {
          const extracted = this.extractNameFromSepaDescription(method.descriptionPayment);
          if (extracted) {
            return {
              ...method,
              name: extracted.name,
              descriptionPayment: extracted.iban
            };
          }
        }
        return method;
      });
    },
    extractNameFromSepaDescription(description) {
      if (!description) return null;
      // Buscar el patrón IBAN que empieza con 2 letras mayúsculas seguidas de 2 dígitos
      // Ejemplo: "Histoires et Slides FR76 3000 4025 8600 0107 1477 196"
      const ibanPattern = /[A-Z]{2}\d{2}/;
      const match = description.match(ibanPattern);
      if (match && match.index > 0) {
        // Extraer el nombre (antes del IBAN) y el IBAN (desde el match en adelante)
        const name = description.substring(0, match.index).trim();
        const iban = description.substring(match.index).trim();
        return { name, iban };
      }
      return null;
    },
    goToDownloadPDF(invoiceId) {
      const loadingData = this.colsInvoices
        .find((col) => col[0].emit === "goToDownloadPDF")[0].loading_data;
      if (loadingData.includes(invoiceId)) return;
      loadingData.push(invoiceId);
      billingsService.downloadInvoice(invoiceId).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename || `invoice-${invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }).finally(() => {
        const i = loadingData.indexOf(invoiceId);
        if (i > -1) loadingData.splice(i, 1);
      });
    },
    getCountry() {
      if (!this.allInfo.paymentProfile || !this.profileCountries) return '';
      let profileCountry = this.profileCountries.filter(
        (item) => item.id == this.allInfo.paymentProfile.country_id
      );

      return profileCountry.length > 0 ? profileCountry[0].name : '';
    },
    getInvoiceId(invoice) {
      let d = new Date(invoice.created);
      let year_digits = d.getFullYear().toString().substr(-2);
      return year_digits + 'OL' + invoice.invoice_id.toString().padStart(10, "0");
    },
    formatCientStats() {
      if (
        this.allInfo.cboStats &&
        this.allInfo.cboStats.length > 0 &&
        this.allInfo.cboStats !== null &&
        this.allInfo.cboStats[0].fdate != null
      ) {
        this.allInfo.cboStats.forEach((item) => {
          const client_id = item.client_id;
          const client_name = item.client_name;
          const fdate = item.fdate;

          if (!this.statsDate.find((field) => field.date == fdate)) {
            this.statsDate.push({ date: fdate });
          }
          if (this.statsClient[client_id] == undefined) {
            this.statsClient[client_id] = {};
            this.statsClient[client_id]["name"] = client_name;
          }
          if (this.statsClient[client_id][fdate] == undefined) {
            this.statsClient[client_id][fdate] = item;

            this.statsType.forEach((type) => {
              if (this.statsClient[client_id][type] == undefined) {
                this.statsClient[client_id][type] = 0;
                this.statsClient[client_id][type + "_amount"] = 0;
              }
              this.statsClient[client_id][type] += parseFloat(item[type]);
              this.statsClient[client_id][type + "_amount"] += parseFloat(
                item[type + "_amount"]
              );
            });
          }
        });

        this.loadingStats = false;
      }
    },
  },
};
</script>
